import {useEffect, useRef} from 'react';

/**
 * useMutation 전용 signal
 * useQuery는 내부적으로 signal 존재하지만 useMutation는 없음
 * cancelToken은 deprecated 대상 (https://axios-http.com/docs/cancellation)
 */
const useAbortSignalOnUnmount = () => {
  const ref = useRef(new AbortController());

  useEffect(() => {
    return () => {
      ref.current.abort();
    };
  }, []);

  return ref.current.signal;
};

export default useAbortSignalOnUnmount;
